import React, { useContext, useEffect, useState } from 'react';
import { TextField, Autocomplete, Select, MenuItem, InputLabel, FormControl, FormGroup, TextareaAutosize, Typography, Box, Divider } from '@mui/material';
import './createStudy.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate, useParams } from 'react-router-dom';
import UserContext from '../../Context/User/userContext';
import moment from 'moment';


const therapeuticAreas = [
  { title: 'Cardiology' },
  { title: 'Oncology' },
  { title: 'Neurology' },
  { title: 'Dermatology' },
  { title: 'Endocrinology' },
  { title: 'Gastroenterology' },
  { title: 'Hematology' },
  { title: 'Immunology' },
  { title: 'Infectious Diseases' },
  { title: 'Nephrology' },
  { title: 'Ophthalmology' },
  { title: 'Orthopedics' },
  { title: 'Pulmonology' },
  { title: 'Rheumatology' },
  { title: 'Urology' },
  { title: 'Psychiatry' },
  { title: 'Pediatrics' },
  { title: 'Obstetrics and Gynecology' },
  { title: 'Otorhinolaryngology' },
  { title: 'Radiology' },
  { title: 'Allergy and Immunology' },
  { title: 'Clinical Pharmacology' },
  { title: 'Medical Genetics' },
  { title: 'Neonatology' },
  { title: 'Nutrition' },
  { title: 'Oncology Surgery' },
  { title: 'Physical Medicine and Rehabilitation' },
  { title: 'Podiatry' },
  { title: 'Sleep Medicine' },
  // Add more therapeutic areas as needed
];
// moment
const StudyForm = ({ setShowSpinner }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState({});
  const [status, setStatus] = useState('active');
  const [phase, setPhase] = useState("Phase I");
  const [manager, setManager] = useState("");
  const [title, setTitle] = useState("");
  const [defaultArea, setDefaultArea] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [indication, setIndication] = useState("");
  const [sponsorName, setSponsorName] = useState("");
  const [activationDate, setActivationDate] = useState(`${new Date().toISOString().slice(0, 10)}`);
  const [submissionDate, setSubmissionDate] = useState(`${new Date().toISOString().slice(0, 10)}`);
  const [CRO, setCRO] = useState("");
  const [criteriaData, setCriteriaData] = useState({ inclusion: '', exclusion: '' });

  const reset = () => {
    setStatus('active');
    setPhase("Phase I");
    setManager('');
    setTitle('');
    setSelectedArea('');
    setIndication('');
    setSponsorName('');
    setActivationDate(`${new Date().toISOString().slice(0, 10)}`);
    setSubmissionDate(`${new Date().toISOString().slice(0, 10)}`);
    setCRO('');
    setCriteriaData({ inclusion: '', exclusion: '' });
  }

  // Bearer Token
  const token = localStorage.getItem('token');
  const tokenValue = token ? token.slice(1, token.length - 1) : "";
  const { user, setUser } = useContext(UserContext);
  const _id = user && (typeof user === 'string' ? JSON.parse(user)._id : user._id);

  const getData = () => {
    axios.post(`https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/specific`,
      {
        _id: id
      }, {
      headers: {
        'Authorization': `Bearer ${tokenValue}`
        // You can add other headers if needed like authorization token, etc.
      }
    })
      .then(res => {
        const response = res.data.data[0];
        setStatus(response.status);
        setPhase(response.phase);
        setManager(response.manager);
        setTitle(response.title);
        setSelectedArea(response.therapeuticAreas);
        setIndication(response.indication);
        setSponsorName(response.sponsorName);
        setActivationDate(response.activationDate);
        setSubmissionDate(response.submissionDate);
        setCRO(response.CRO);
        setCriteriaData({ inclusion: response.inclusionCriteria, exclusion: response.exclusionCriteria });
        setData(response);
      })
      .catch(error => {
        console.log(error.response?.data?.message);
      })
      .finally(() => {
        setShowSpinner(false);
      })
  }

  useEffect(() => {
    if (id && id !== 'false') {
      getData()
      const defaultOption = therapeuticAreas.find(area => area.title === 'Cardiology');
      setDefaultArea(defaultOption);
    }
  }, [])

  const handleSubmit = () => {
    setShowSpinner(true);
    const adminStudy = {
      status,
      phase,
      title,
      therapeuticAreas: selectedArea,
      indication,
      sponsorName,
      manager,
      activationDate,
      submissionDate,
      CRO,
      inclusionCriteria: criteriaData.inclusion,
      exclusionCriteria: criteriaData.exclusion,
      addedBy: _id,
    }
    if (id && id === 'false') {
      const url = 'https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/';
      axios.post(url, adminStudy, {
        headers: {
          'Authorization': `Bearer ${tokenValue}`
          // Add other headers if needed
        }
      })
        .then(res => {
          Swal.fire({
            icon: "success",
            title: "Added...",
            text: res.data.message,
            customClass: {
              container: 'swal2-container-custom'
            }
          });
          reset()
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response?.data?.message,
            customClass: {
              container: 'swal2-container-custom'
            }
          });
        })
        .finally(() => {
          setShowSpinner(false);
        })
    } else {
      if (status !== "developing") {
        const url = `https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/updateStatus/${data._id}`;
        axios.post(url, adminStudy, {
          headers: {
            'Authorization': `Bearer ${tokenValue}`
            // Add other headers if needed
          }
        })
          .then(res => {
            Swal.fire({
              icon: "success",
              title: "Added...",
              text: res.data.message,
              customClass: {
                container: 'swal2-container-custom'
              }
            })
              .then(() => {
                navigate('/developingStudy')
              })
            reset()
          })
          .catch(error => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.response?.data?.message,
              customClass: {
                container: 'swal2-container-custom'
              }
            });
          })
          .finally(() => {
            setShowSpinner(false);
          })
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Study status is already developing',
          customClass: {
            container: 'swal2-container-custom'
          }
        });
        setShowSpinner(false)
      }
    }
  }

  return (
    <Box sx={{ p: 3, color: '#169a8f', fontWeight: 'bold' }}>
      <div>
      <h4 style={{color:'rgb(23 131 131)'}}>create Study</h4>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <button className="button " data-text="Awesome" onClick={handleSubmit}>
            <span className="actual-text">&nbsp;SaveStudy&nbsp;</span>
            <span aria-hidden="true" className="hover-text">&nbsp;SaveStudy&nbsp;</span>
          </button>
        </Box>
      </div>

      <Divider />
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">Study Criteria</Typography>
        <FormGroup row sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
          <FormControl sx={{ mr: 3 }}>
            <InputLabel id="status-label">Status</InputLabel>
            <Select labelId="status-label" id="status" value={status} label="Status" onChange={e => setStatus(e.target.value)}>
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="developing">Developing</MenuItem>
              <MenuItem value="close">Close</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ mr: 3 }}>
            <InputLabel id="phase-label">Phase</InputLabel>
            <Select labelId="phase-label" id="phase" value={phase} label="Phase" onChange={e => setPhase(e.target.value)}>
              <MenuItem value={"Phase I"}>Phase I</MenuItem>
              <MenuItem value={"Phase II"}>Phase II</MenuItem>
              <MenuItem value={"Phase III"}>Phase III</MenuItem>
              <MenuItem value={"Phase IV"}>Phase IV</MenuItem>
            </Select>
          </FormControl>
          <TextField
            id="activation-date"
            label="Activation Date"
            type="date"
            value={activationDate}
            InputLabelProps={{ shrink: true }}
            sx={{ mr: 3 }}
            onChange={e => setActivationDate(e.target.value)}
          />
          <TextField
            id="submission-date"
            label="Submission Date"
            type="date"
            value={submissionDate}
            InputLabelProps={{ shrink: true }}
            onChange={e => setSubmissionDate(e.target.value)}
          />
          <FormControl sx={{ mx: 3 }}>
            <InputLabel id="manager-label">Manager</InputLabel>
            <Select labelId="manager-label" id="manager" value={manager} label="manger" onChange={e => setManager(e.target.value)}
              style={{ fontSize: 15, minWidth: '160px' }}
              MenuProps={{ // Style for menu options
                PaperProps: {
                  style: {
                    maxHeight: 300,
                    width: '20ch',
                  },
                },
              }}>
              <MenuItem value={"Maheen"}>Maheen</MenuItem>
              <MenuItem value={"Wardah"}>Wardah</MenuItem>
              <MenuItem value={"Evelyn"}>Evelyn</MenuItem>
              <MenuItem value={"Shariq"}>Shariq</MenuItem>
              <MenuItem value={"Ibrahim"}>Ibrahim</MenuItem>
              <MenuItem value={"Owais"}>Owais</MenuItem>

            </Select>
          </FormControl>
        </FormGroup>

        <TextField
          id="input-title"
          label="Title"
          fullWidth
          sx={{ mt: 2 }}
          onChange={e => setTitle(e.target.value)}
          value={title}
        />
        {
          (id && id === 'false') ?
            <Autocomplete
              id="therapeutic-areas"
              options={therapeuticAreas}
              getOptionLabel={(option) => option.title}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Therapeutic Areas"
                  fullWidth
                  onBlur={e => setSelectedArea(e.target.value)}
                />)}
              sx={{ mt: 2 }}
            />
            :
            <Autocomplete
              id="therapeutic-areas"
              options={therapeuticAreas}
              getOptionLabel={(option) => option.title}
              value={defaultArea}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Therapeutic Areas"
                  fullWidth
                  onBlur={e => setSelectedArea(e.target.value)}
                />)}
              sx={{ mt: 2 }}
            />
        }



        <TextField
          id="indication"
          label="Indication"
          fullWidth sx={{ mt: 2 }}
          onChange={e => setIndication(e.target.value)}
          value={indication}
        />
      </Box>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">Study Sponsors</Typography>
        <FormGroup row sx={{ mt: 2 }}>
          <TextField
            id="name-sponsors"
            label="Name Sponsors"
            sx={{ mr: 3 }}
            value={sponsorName}
            onChange={e => setSponsorName(e.target.value)}
          />
          <TextField
            id="cro"
            label="CRO"
            value={CRO}
            onChange={e => setCRO(e.target.value)}
          />
        </FormGroup>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Divider />
        <Typography variant="h6" sx={{ mt: 2 }}>Criteria</Typography>
        <Box sx={{ mt: 2 }}>
          <TextField
            id="inclusion-criteria"
            label="Inclusion Criteria"
            multiline
            rows={6}
            fullWidth
            value={criteriaData.inclusion}
            onChange={(e) => setCriteriaData({ ...criteriaData, inclusion: e.target.value })}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <TextField
            id="exclusion-criteria"
            label="Exclusion Criteria"
            multiline
            rows={6}
            fullWidth
            value={criteriaData.exclusion}
            onChange={(e) => setCriteriaData({ ...criteriaData, exclusion: e.target.value })}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default StudyForm;